import React from 'react';

const ServerUnavailable = () => (
    <div style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        minHeight: '300px',
        padding: '2rem',
        textAlign: 'center',
    }}>
        <h2 style={{ marginBottom: '0.75rem', fontSize: '1.4rem' }}>
            Currently Undergoing Maintenance
        </h2>
        <p style={{ color: '#666', maxWidth: '500px' }}>
            The solar calculator is currently undergoing maintenance.
            Please check back shortly.
        </p>
    </div>
);

export default ServerUnavailable;
